import {BookingsApp} from "./Functionality/BookingsApp";
import {RESERVATIONS_SUB_VIEW_MODEL} from "./Model/Model";
import Events from "./Requested/Events";
import ReservationsStatus from "./Status/ReservationsStatus";
import {permissionObj} from "../../../Helpers/permission";


/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const Bookings = ({
                      selectedList,
                      setSelectedList,
                      search,
                      setSearch,
                      simpleSearch,
                      setSimpleSearch,
                      sendSimpleSearch,
                      setSendSimpleSearch,
                      bodyForExport,
                      setBodyForExport,
                      searchElement,
                      setSearchElement,
                      reservationRef,
                      option,
                      moduleId,
                      subView,
                      setSubView
                  }) => {

    const { DEV, permission, handleSubViewChange } = BookingsApp({
        setSubView,
        setSelectedList,
        setSearchElement,
        setSearch
    })

    return (
        <>
            { (subView === RESERVATIONS_SUB_VIEW_MODEL.BOOKINGS.REQUEST  && (DEV || permission?.includes(permissionObj?.WEB_EVENT_READ)) ) && (
                <Events
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    bodyForExport={bodyForExport}
                    ref={reservationRef}
                    moduleId={moduleId}
                    subView={subView}
                    handleSubViewChange={handleSubViewChange}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    permission={permission}
                    DEV={DEV}
                    option={option}
                    setSearch={setSearch}
                    simpleSearch={simpleSearch}
                    setSimpleSearch={setSimpleSearch}
                    search={search}
                    sendSimpleSearch={sendSimpleSearch}
                    setSendSimpleSearch={setSendSimpleSearch}
                    setBodyForExport={setBodyForExport}
                />
            )}

            { (subView === RESERVATIONS_SUB_VIEW_MODEL.BOOKINGS.STATUS && ( DEV || permission?.includes(permissionObj?.WEB_EVENT_STATUS_READ) ) ) && (
                <ReservationsStatus
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    bodyForExport={bodyForExport}
                    ref={reservationRef}
                    moduleId={moduleId}
                    subView={subView}
                    handleSubViewChange={handleSubViewChange}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    permission={permission}
                    DEV={DEV}
                    option={option}
                    setSearch={setSearch}
                    simpleSearch={simpleSearch}
                    setSimpleSearch={setSimpleSearch}
                    search={search}
                    sendSimpleSearch={sendSimpleSearch}
                    setSendSimpleSearch={setSendSimpleSearch}
                    setBodyForExport={setBodyForExport}
                />
            )}

        </>
    );
};

export default Bookings
